'use client';

import { isUseProductionEnv } from '@/constants/is-use-production-env';
import { CategoryInterface, CategoryProducts, Maybe } from '@/types/graphql.prod';
import { fetchClientIp } from '@/util/fetch-client-ip';
import { useEffect } from 'react';

export interface CategoryDataType {
  categories: { items: Maybe<Array<Maybe<CategoryInterface>>> };
  products: Maybe<CategoryProducts>;
}

export const useGetCategoryDetail = ({ categoryDetail }: { categoryDetail: any }) => {
  useEffect(() => {
    (async () => {
      if (!categoryDetail) return;

      const { products, categories } = categoryDetail;

      try {
        const productItems = products?.items?.map(temp => {
          return {
            item_name: temp?.name,
            item_id: temp?.sku,
            quantity: 1,
          };
        });

        const productItemsForPintrk = products?.items?.map(temp => {
          return {
            product_name: temp?.name,
            product_id: temp?.uid,
            product_category: categories?.items?.[0]?.meta_title,
            product_price: temp?.price_range?.maximum_price?.final_price.value,
            product_brand: 'kingsyard',
          };
        });

        // 清除之前的ecommerce对象
        window.dataLayer &&
          window.dataLayer.push({
            ecommerce: null,
          });
        // 推送新的事件
        const ga4Payload = {
          event: 'view_item_list',
          ecommerce: {
            item_list_id: categories?.items?.[0]?.name,
            item_list_name: categories?.items?.[0]?.name,
            items: productItems,
          },
        };
        console.log('👉 [GA4 Event] view_item_list triggered', ga4Payload);
        window.dataLayer && window.dataLayer.push(ga4Payload);

        window.pintrk &&
          window.pintrk('track', 'viewcategory', {
            line_items: productItemsForPintrk,
          });
      } catch (err) {
        console.error(err);
      }

      // Track with Pinterest Conversion API
      try {
        if (isUseProductionEnv) {
          fetchClientIp().then(currentIp => {
            fetch('/api/pinterest-view-category', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                eventName: 'view_category',
                product: {
                  items: products?.items,
                  category: categories?.items?.[0],
                },
                ip: currentIp,
              }),
            });
          });
        }
      } catch (err) {
        console.error('Pinterest conversion error:', err);
      }
    })();
  }, [categoryDetail]);

  const categoryShortDes =
    categoryDetail && categoryDetail?.categories?.items?.length
      ? categoryDetail?.categories?.items?.[0]?.short_description
      : null;

  const categoryNotFound = categoryDetail?.categories?.items?.length === 0;

  const noProducts = categoryDetail?.products?.items?.length === 0;

  return {
    getCategoryDetailLoading: false,
    categoriesData: categoryDetail,
    categoryShortDes,
    categoryNotFound,
    noProducts,
    error: null,
  };
};
